import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { Input } from '../../lib/form/fields';
import { requiredField, compareField } from '../../lib/form/validators';

const CreatePasswordForm = ({ valid, handleSubmit, onSubmit, loading }, context) => {
  const [state, setState] = useState({ pwdUnmasked: false });
  const pwdMaskToggle = () => {
    setState({ pwdUnmasked: !state.pwdUnmasked });
  };
  return (
    <form onSubmit={handleSubmit(values => onSubmit(values))}>
      <Field
        name="password"
        type={state.pwdUnmasked ? 'text' : 'password'}
        label={context.t('CREATE-PASSWORD-FORM.PASSWORD.LABEL')}
        placeholder={context.t('CREATE-PASSWORD-FORM.PASSWORD.PLACEHOLDER')}
        component={Input}
        appendInput={
          <span
            className={`input-group-text ${state.pwdUnmasked ? 'text-primary' : ''}`}
            onClick={() => pwdMaskToggle()}
          >
            <i className="fa fa-eye" />
          </span>
        }
      />

      <Field
        name="password_confirm"
        type={state.pwdUnmasked ? 'text' : 'password'}
        label={context.t('CREATE-PASSWORD-FORM.PASSWORD-CONFIRM.LABEL')}
        placeholder={context.t('CREATE-PASSWORD-FORM.PASSWORD-CONFIRM.PLACEHOLDER')}
        component={Input}
        appendInput={
          <span
            className={`input-group-text ${state.pwdUnmasked ? 'text-primary' : ''}`}
            onClick={() => pwdMaskToggle()}
          >
            <i className="fa fa-eye" />
          </span>
        }
      />

      <button className="btn btn-lg btn-block btn-primary mb-3" disabled={!valid}>
        {context.t('CREATE-PASSWORD-FORM.BUTTON.SUBMIT')}
        {loading && (
          <div className="spinner-border spinner-border-sm ml-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </button>
    </form>
  );
};

CreatePasswordForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const resetPasswordFormValidator = formProps => {
  const errors = {};
  requiredField(formProps, errors, 'password', 'CREATE-PASSWORD-FORM.PASSWORD.ERROR_REQUIRED');
  compareField(
    formProps,
    errors,
    'password_confirm',
    'password',
    'CREATE-PASSWORD-FORM.PASSWORD-CONFIRM.ERROR_MISMATCH'
  );
  return errors;
};

export default reduxForm({
  form: 'CreatePasswordForm',
  validate: resetPasswordFormValidator,
})(CreatePasswordForm);
